import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface ShopifyLink {
  forceRedirect?: boolean;
  path: string;
  shopifyLink: string;
}

@Injectable({ providedIn: 'root' })
export class ShopifyMigrationService {
  constructor(
    private http: HttpClient
  ) {}

  getShopifyLinks() {
    return this.http.get<ShopifyLink[]>(environment.shopifyMigration.getShopifyLinks);
  }

  updateShopifyLink(link: ShopifyLink) {
    return this.http.post(environment.shopifyMigration.updateShopifyLink, link);
  }
}
